import styled from 'styled-components/macro';

const COLLAPSED_WIDTH = 56;
const CHEVRON_COLUMN_WIDTH = 40;
const EXPANDED_BASIS = 328;

export const CollapsibleCardWrapStyled = styled.div<{ $collapsed: boolean }>`
  display: flex;
  flex-direction: ${({ $collapsed }): string => ($collapsed ? 'column' : 'row')};
  flex: ${({ $collapsed }): string =>
    $collapsed ? `0 0 ${COLLAPSED_WIDTH}px` : `1 1 ${EXPANDED_BASIS}px`};
  min-width: ${({ $collapsed }): string => ($collapsed ? `${COLLAPSED_WIDTH}px` : '0')};
  min-height: 230px;
  height: 230px;
  align-self: stretch;
  background-color: ${({ theme }): string => theme.colors.surface};
  border-radius: 12px;
  border: 2px solid transparent;
  box-shadow: ${({ theme }): string => theme.shadows.variant1};
  box-sizing: border-box;
  overflow: visible;
  outline: none;
  transition: flex 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus-within {
    border-color: ${({ theme }): string => theme.colors.focusRing};
    box-shadow: ${({ theme }): string => theme.shadows.variant1},
      0 0 4px 2px ${({ theme }): string => theme.colors.focusRing};
  }

  /* Suppress inner InfoCard focus ring – outer card provides it */
  & > *:last-child div[class]:focus-within {
    border-color: transparent !important;
    box-shadow: none !important;
  }
`;

export const CollapsibleCardHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 40px;
  padding: 4px 8px 6px;
  box-sizing: border-box;
`;

export const CollapsibleChevronColumnStyled = styled.div`
  flex: 0 0 ${CHEVRON_COLUMN_WIDTH}px;
  width: ${CHEVRON_COLUMN_WIDTH}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 0 0 18px;
  flex-shrink: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
`;

export const CollapsibleCardCollapsedStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  padding-top: 16px;
  min-height: 150px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const CollapsibleCardContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding-left: 8px;
`;
